var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('FolderTagPreview',{attrs:{"id":_vm.fileid,"name":_vm.basename,"path":_vm.filename,"file-list":_vm.fileList}})}
var staticRenderFns = []

export { render, staticRenderFns }